<div nz-row nzType="flex">
  <div nz-col nzSpan="7">
    <div style="font-size: 13px;" class="formname">{{ formTitle }}</div>
  </div>

  <div nz-col nzSpan="17" style="display: flex; justify-content: flex-end">
    <form nz-form [nzLayout]="'inline'">
      <nz-form-item>
        <nz-form-control>
          <nz-date-picker [(ngModel)]="month" style="width: 100% ; font-size: 11px !important" nzFormat="MMM yyyy" name="selectMonth2"
            nzPlaceHolder="Select month" (ngModelChange)="yearChange($event)" [nzDisabledDate]="disabledDate"
            nzMode="month"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <button nz-button nzType="primary" style="margin-right: 0px" (click)="importInExcel()"
          [nzLoading]="loadprojectexcel">
          <i nz-icon nzType="file-excel" nzTheme="outline"></i>
        </button>
      </nz-form-item>
    </form>
  </div>
</div>

<div nz-row>
  <div nz-col nzSpan="24">
    <nz-table class="my-scroll no-wrap1" nzBordered #table nzShowSizeChanger [nzFrontPagination]="false"
    [nzData]="projectData" nzSize="small" [nzLoading]="loadingRecords" [nzScroll]="{ y: '360px' }">
    <thead>
      <tr>
        <th nzLeft style="text-align: center; padding: 2px;" nzWidth="200px">
          <b style="font-size: 12px !important">Project Name</b>
        </th>
        <th style="text-align: center; padding: 2px;" nzWidth="120px">
          <b style="font-size: 12px !important">Total Amount</b>
        </th>
        <th style="text-align: center; padding: 2px;" nzWidth="120px">
          <b style="font-size: 12px !important">Total Time</b>
        </th>
        <th style="text-align: center; padding: 2px;" nzWidth="120px">
          <b style="font-size: 12px !important">Invoice Raised</b>
        </th>
        <th style="text-align: center; padding: 2px;" nzWidth="120px">
          <b style="font-size: 12px !important">Received</b>
        </th>
        <th style="text-align: center; padding: 2px;" nzWidth="120px">
          <b style="font-size: 12px !important">Pending</b>
        </th>
         <!-- Added column for Total Days -->
    <th style="text-align: center; padding: 2px;" nzRight nzWidth="120px">
      <b style="font-size: 12px !important">Total Days</b>
    </th>
      </tr>
    </thead>
  
    <tbody>
      <tr *ngFor="let data of projectData; let i = index" style="cursor: pointer">
        <td nzLeft style="text-align: left; white-space: pre-line; padding: 2px;" nzWidth="200px"
          nz-tooltip [nzTooltipTitle]="data.PROJECT_NAME">
          {{ data.PROJECT_NAME }}
        </td>
        <td style="text-align: right; white-space: pre-line; padding: 2px;" nzWidth="120px" nz-tooltip
          [nzTooltipTitle]="data.TOTAL_AMOUNT | number: '1.2-2'">
          {{ data.TOTAL_AMOUNT | number: '1.2-2' }}
        </td>
        <td style="text-align: center; white-space: pre-line; padding: 2px;" nzWidth="120px" nz-tooltip
          [nzTooltipTitle]="data.TOTAL_TIME">
          {{ data.TOTAL_TIME  }}
        </td>
        <td style="text-align: center; padding: 2px;" nzWidth="120px">
          <input nz-input style="font-size: 11px !important; " [(ngModel)]="data.INVOICE_RAISED" (input)="limitLength($event, 9)"
            (ngModelChange)="calculatePending(data, i)" type="number" />
        </td>
        <td style="text-align: center; padding: 2px;" nzWidth="120px">
          <input nz-input style="font-size: 11px !important; " [(ngModel)]="data.RECIVED" (input)="limitLength($event, 9)"
            (ngModelChange)="calculatePending(data, i)" type="number" />
        </td>
        <td style="text-align: center; padding: 2px;" nzWidth="120px">
          <input nz-input style="font-size: 11px !important; " [value]="data.PENDING" (input)="limitLength($event, 9)" type="number" disabled />
        </td>
        <!-- Added column for Total Days -->
        <td style="text-align: center; padding: 2px;" nzRight nzWidth="120px">
          {{ data.TOTAL_DAYS  }}
        </td>
      </tr>
    
      <!-- Total Row -->
      <tr *ngIf="isTotalRow && projectData.length > 0" style="font-weight: bold; background-color: #f0f0f0;">
        <td nzLeft style="text-align: left; white-space: pre-line; padding: 2px;background-color: #f0f0f0">Total</td>
        <td style="text-align: right; white-space: pre-line; padding: 2px;">
          {{ totalAmount | number: '1.2-2' }}
        </td>
        <td style="text-align: center; white-space: pre-line; padding: 2px;">
          {{ totalTime }}
        </td>
        <td style="text-align: center; white-space: pre-line; padding: 2px;">
          {{ totalInvoiceRaised | number: '1.2-2' }}
        </td>
        <td style="text-align: center; white-space: pre-line; padding: 2px;">
          {{ totalReceived | number: '1.2-2' }}
        </td>
        <td style="text-align: center; white-space: pre-line; padding: 2px;">
          {{ totalPending | number: '1.2-2' }}
        </td>
        <!-- Added Total for Total Days -->
        <td nzRight style="background-color: #f0f0f0;text-align: center; white-space: pre-line; padding: 2px;">
          {{ totalDays  }}
        </td>
      </tr>
    </tbody>
    
  </nz-table>
  
  </div>

  <div nz-col *ngIf="projectData.length > 0" nzSpan="24" style="display: flex; justify-content: flex-end">
    <!-- <label for=""> {{projectData | json}}</label> -->
    <nz-form-item style="margin-right: 0px">
      <button nz-button nzType="primary" style="font-size: 11px;" [nzLoading]="updatemonthrecords" (click)="UpdateMonthData()">
        Update Month Data
      </button>
    </nz-form-item>
  </div>
</div>